var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPPrimeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.526367,
    width: 36.1057,
    height: 36.1057,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7373 17.9632C25.5682 18.0621 25.5682 19.2678 24.7373 19.3667L19.8576 19.9474C19.533 19.986 19.2773 20.2422 19.2392 20.5668L18.6676 25.4415C18.5699 26.2739 17.3615 26.2739 17.2638 25.4415L16.6921 20.5668C16.6541 20.2422 16.3983 19.986 16.0738 19.9474L11.1941 19.3667C10.3632 19.2678 10.3632 18.0621 11.1941 17.9632L16.0738 17.3826C16.3983 17.344 16.6541 17.0878 16.6921 16.7632L17.2638 11.8885C17.3615 11.056 18.5699 11.056 18.6676 11.8885L19.2392 16.7632C19.2773 17.0878 19.533 17.344 19.8576 17.3826L24.7373 17.9632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPrimeLogo);
export default __webpack_public_path__ + "static/media/p-prime-logo.fa6d9b6bdf56cdb7c93293089caaec69.svg";
export { ForwardRef as ReactComponent };